// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5ad215decfd2092e764afe6997d3e4d1aec4e2f7';
export const BUILD_NUMBER = '227';
export const BUILD_TIMESTAMP = '2026-09-08T01:27:50.400Z';
